module.exports = __webpack_public_path__ + "img/ad2.283504be.jpg";